import script from "./PageNotFound.vue?vue&type=script&setup=true&lang=js"
export * from "./PageNotFound.vue?vue&type=script&setup=true&lang=js"

import "./PageNotFound.vue?vue&type=style&index=0&id=3e1b655b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e1b655b"]])

export default __exports__